import React, {useEffect,useState,useRef} from 'react';
import {Popover,Alert, Empty,message} from 'antd';
import useHandleError from "utils/useHandleError";
import apiClient from "utils/apiClient";
import { useIntl} from 'react-intl';
import Spinner from "components/Spinner";
import './styles.scss';

const NotificationDropdown: React.FC<any> = ({ isMobile}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notifications, setNotifications] = useState<any[]>([]);

  const [handleError] = useHandleError();
  const intl = useIntl();
  const Ref = useRef<any>(null)
  const hasMarkedAsReadRef = useRef<boolean>(false);
  const intervalTime = 300000;

  useEffect(() => {
      startTimer()

      return () => {
        if(Ref.current) {
          clearInterval(Ref.current);
        }
      }
  }, [])

  useEffect(() => {
      if(isOpen) {
        startTimer()
        if (!hasMarkedAsReadRef.current && notifications.length > 0) {
          notifications.forEach((notification) => {
            if (!notification.isRead) {
              markAsRead(notification.id);
            }
          });
          hasMarkedAsReadRef.current = true;
        }
      } else {
        hasMarkedAsReadRef.current = false;
      }
  }, [isOpen])

  const startTimer = () => {
    if(Ref.current) {
      clearInterval(Ref.current);
    }
    
    loadNotifications()
    const id = setInterval(() => {
      if(!isLoading) {
        loadNotifications()
      }
    }, intervalTime)
    
    Ref.current = id;
  }

  const loadNotifications = async () => {
    if(isLoading) {
      return;
    }
    
    setIsLoading(true);
    try {
        const response = await apiClient.request(`/api/v1/general-messaging/get-user-messages`, [], 'GET');
        setNotifications(response.generalMessages)

    } catch (error) {
        handleError(error)
    } finally {
        setIsLoading(false);
    }
  }
  
  const getAlertType = (type: string) => {
    switch (type) {
      case 'ALERT':
        return 'warning';

      default:
        return 'info';
    }
  };

  const renderMessage = (item: any) => {
    if (item.systemType && item.referenceData?.submissionUuid) {
      return intl.formatMessage(
        { id: item.message, defaultMessage: item.message },
        {
          link: (
            <a href={`/assessment/${item.referenceData.submissionUuid}`}>
                {intl.formatMessage({ id: 'general.view' })}
            </a>
          ),
        }
      );
    }

    return item.message;
  };

  const markAsRead = async (id: number) => {
    setNotifications(prev => prev.map(n => n.id === id ? { ...n, isRead: true } : n));

    try {
      const response = await apiClient.request(`/api/v1/user-notifications/${id}/mark-as-read`, {}, 'PUT', true);
      
      if (response.success) {
        setNotifications(prev => prev.map(n => n.id === id ? { ...n, isRead: true } : n));
      }
    } catch (error) {
      handleError(error);
    }
  };
  
  const unreadCount =  notifications.filter(n => !n.isRead).length;
  
  const PopoverContent = () => {
    return (
      <div className='notification-content' style={{width: '300px'}}>
        <Spinner spinning={isLoading}>
        {
          notifications.length > 0 ? notifications.map((item:any, key:number) => {
            return (
              <div key={key}>
                <Alert
                  type={getAlertType(item.type)}
                  message={renderMessage(item)}
                  showIcon
                />
              </div>
            )
          }) : <Empty description={intl.formatMessage({id: 'general_messaging.no_messages'})} />
        }
        </Spinner>
      </div>
    )
  };

  return <div className={isMobile ? 'session-switch-item-mobile' : 'session-switch-item'}>
    <Popover
      placement='bottomRight'
      content={<PopoverContent />}
      overlayClassName='session-switch-popover notifications-popover'
      //arrowContent={false}
      open={isOpen}
      trigger='click'
      onOpenChange={() => setIsOpen(!isOpen)}
      title={intl.formatMessage({id: 'general_messaging.notifications'})}
    >
      <div className='role-switch notifications-dropdown'>
        <i className='fal fa-bell with-accent' />
        {unreadCount > 0 && <div className='notifications-dot'></div>}
      </div>
    </Popover>
  </div>
}

export default NotificationDropdown;
